module.exports = __webpack_public_path__ + "media/images/iconPaginateFirst__okGreen--dark-8c012a469ce4caa8ff86f09be7c13f31.png";